import { Children } from "react";

import { Text } from "@aprosoja/ui";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";

const Summary = () => {
  const { signUpReducer } = useSignUpContext();

  return (
    <div className="flex flex-col min-w-[400px] h-fit rounded-border-radius-large gap-size-x8 py-size-x10 px-size-x8 bg-th-color-neutral-100">
      <Text type="headingL">Resumo</Text>
      <div className="flex flex-col gap-size-x4">
        <div className="flex gap-size-x4">
          <Text>Propriedade</Text>
          <div className="flex flex-col w-full gap-size-x4">
            {Children.toArray(
              signUpReducer?.calculationResults?.properties?.map((property) => (
                <div className="flex flex-col gap-size-base items-end">
                  <Text
                    type="paragraphL"
                    color="th-primary-color-main"
                    className="text-nowrap"
                  >
                    {property.area}Ha, {property.plantedCulture}
                  </Text>
                  <Text type="paragraphL" color="th-primary-color-main">
                    {property.city?.label ? `${property.city.label}/` : ""}
                    {property.state?.label}
                  </Text>
                </div>
              ))
            )}
          </div>
        </div>
        <div className="flex w-full h-[1px] bg-th-color-neutral-900" />
        <div className="flex items-center justify-between">
          <Text type="headingS">Total</Text>
          <Text type="headingS" color="th-primary-color-main">
            R${" "}
            {signUpReducer?.calculationResults?.annualPayment
              .toFixed(2)
              .replace(".", ",")}{" "}
            <Text type="paragraphL">Anual</Text>
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Summary;
